<style>

    .v-event-book-checkmark {
        color: white;
        position: absolute;
        top:0px;
        right:5px;
        font-size: 20px;
    }

    .event-selector .product {
        cursor: pointer;
        min-height: 100px;
    }

    .event-selector .product-short-description {
        height: 50px;
    }

    .event-selector .group-box {
        border: solid 1px #efefef;
        padding: 20px;
    }

</style>
<template>

    <div class="event-selector">

        <div v-show="dataStep === 1" class="animated fadeIn">
            <h5 class="pb-0 mb-0">{{Core.Definition.getDefinition('Étape 1 - Sélectionnez un produit')}}</h5><br/>
            <small>
                {{Core.Definition.getDefinition('Cliquez sur l\'un des produits de votre choix.')}}
            </small>
            <hr/>
            <Request
                    ref="products"
                    :onRequestSuccess="onRequestSuccessProducts"
                    root="/velorail-booking/products">
                <slot slot="body">
                    <b-row>
                        <b-col class="product" @click="selectProduct(product)" v-for="product in dataProductOptions" lg="3" md="4">
                            <div class="card v-settings-menu-item">
                                <div class="card-body">
                                    <h5>{{product.title}}</h5>
                                    <div class="product-short-description">
                                        <small>
                                            {{product.shortDescription}}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </slot>
            </Request>
        </div>

        <div v-show="dataStep === 2" class="animated fadeIn">
            <h5 class="pb-0 mb-0">{{Core.Definition.getDefinition('Étape 2 - Spécifiez les participants')}}</h5><br/>
            <small>
                {{Core.Definition.getDefinition('Entrez le nombre de participants puis complétez les informations de chacun.')}}
            </small>
            <hr/>

            <b-row>
                <b-col class="group-box" v-for="product, productIndex in dataGroups" lg="6" sm="12">
                    <strong>{{ product.title + ' #' + (productIndex+1)}}</strong><br/><br/>

                    <div>
                        <b-alert :show="product.messages.length > 0" variant="danger">
                            <ul class="m-0 p-2">
                                <li v-for="message in product.messages">
                                    <i class="fa fa-time"></i>&nbsp;
                                    {{message}}
                                </li>
                            </ul>
                        </b-alert>
                    </div>

                    <table width="100%" class="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>{{Core.Definition.getDefinition('Prénom')}}</th>
                                <th>{{Core.Definition.getDefinition('Age')}}</th>
                                <th>{{Core.Definition.getDefinition('Poids (LBS)')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="participant, participantIndex in product.participants">
                                <td>
                                    {{Core.Definition.getDefinition('Place #') + (participantIndex+1)}}
                                </td>
                                <td>
                                    <b-input @change="validateGroups" v-model="product.participants[participantIndex].firstname" :placeholder="Core.Definition.getDefinition('Prénom')" type="text"></b-input>
                                </td>
                                <td>
                                    <b-select @change="validateGroups" v-model="product.participants[participantIndex].age">
                                        <option value="">
                                            {{Core.Definition.getDefinition('Age')}}
                                        </option>
                                        <option :value="option.value" v-for="option in getAgeOptions()">
                                            {{option.label}}
                                        </option>
                                    </b-select>
                                </td>
                                <td>
                                    <b-select @change="validateGroups" v-model="product.participants[participantIndex].weight">
                                        <option value="">
                                            {{Core.Definition.getDefinition('Poids')}}
                                        </option>
                                        <option :value="option.value" v-for="option in getWeightOptions()">
                                            {{option.label}}
                                        </option>
                                    </b-select>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <b-button v-if="productIndex > 0" @click="onClickTrashProduct(productIndex)" class="btn btn-danger">
                        <i class="fa fa-trash-o"></i> {{Core.Definition.getDefinition('Retirer le vélorail')}}
                    </b-button>
                </b-col>

                <b-col lg="6">
                    <b-button @click="onClickAddProduct" class="btn btn-light mt-4">
                        <i class="fa fa-plus"></i> {{Core.Definition.getDefinition('Ajouter un vélorail')}}
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <div v-show="dataStep === 3" class="animated fadeIn">
            <h5 class="pb-0 mb-0">{{Core.Definition.getDefinition('Étape 3 - Sélectionnez une date')}}</h5><br/>
            <small>
                {{Core.Definition.getDefinition('Choissisez une date parmi les dates disponibles.')}}
            </small>
            <hr/>
            <EventBooking
                    v-if="dataStep === 3"
                    ref="eventBooking"
                    :product="regroup()"
                    :productId="this.dataProduct.id"
                    :minBookingLeft="this.dataGroups.length">
            </EventBooking>
        </div>

        <div v-show="dataStep === 4" class="animated fadeIn">

        </div>

        <b-row class="mt-4" v-if="dataStep > 1">
            <b-col>
                <hr/>
                <b-alert variant="danger" :show="dataAlert.show">
                    {{dataAlert.message}}
                </b-alert>
                <b-button-group>
                    <b-button :disabled="dataStep === 1 || dataDisablePrev" @click="onClickPrev" class="btn btn-light"><i class="fa fa-chevron-left"></i>&nbsp;{{Core.Definition.getDefinition('Précédent')}}</b-button>
                    <b-button :disabled="dataStep === 3 || dataDisableNext || dataAllParticipantsAreValid === false" @click="onClickNext" class="btn btn-light">{{Core.Definition.getDefinition('Suivant')}}&nbsp;<i class="fa fa-chevron-right"></i></b-button>
                </b-button-group>
            </b-col>
        </b-row>

    </div>

</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import Request from '../../components/Request'
    import CalendarWeek from '../../components/CalendarWeek'
    import CalendarMonth from '../../components/CalendarMonth'
    import EventList from '../../components/EventList'
    import WeekPagination from '../../components/WeekPagination'
    import ModalConfirm from '../../components/ModalConfirm'
    import InputQuantity from '../../components/InputQuantity'
    import InputText from '../../components/InputText'
    import InputSelect from '../../components/InputSelect'
    import InstanceSelector from '../../components/InstanceSelector'
    import Modal from '../../components/Modal'
    import ModalLogin from '../../components/ModalLogin'
    import ModalCreateAccount from '../../components/ModalCreateAccount'
    import EmbeddedPurchase from '../../components/EmbeddedPurchase'
    import CForm from '../../components/CForm'
    import PluginRequest from '../../components/PluginRequest'
    import EventBooking from './EventBooking'
    export default {
        name: 'VelorailBooking',
        components: {
            CalendarWeek,
            CalendarMonth,
            WeekPagination,
            EventList,
            ModalConfirm,
            Request,
            InputQuantity,
            InputText,
            InputSelect,
            InstanceSelector,
            Modal,
            ModalLogin,
            ModalCreateAccount,
            EmbeddedPurchase,
            CForm,
            PluginRequest,
            EventBooking
        },
        props: {
        },
        watch: {
        },
        mounted() {
            this.$refs.products.request()
        },
        data: function () {
            return {
                Vue: Vue,
                Core: window.Core,
                Mantle: window.Mantle,
                dataStep: 1,
                dataProductOptions: [],
                dataGroups: [],
                dataProduct: {},
                dataDisplayNavigation: false,
                dataDisableNext: false,
                dataDisablePrev: false,
                dataAlert: {
                    show: false,
                    message: ''
                },
                dataAllParticipantsAreValid: false
            }
        },
        methods: {
            regroup() {
                let product = {
                    id: this.dataProduct.id,
                    data: Core.Array.newObject(this.dataProduct),
                    quantity: this.dataGroups.length
                }

                let participants = []
                for(let group in this.dataGroups) {
                    group = this.dataGroups[group]
                    for(let participant in group.participants)
                    {
                        participant = group.participants[participant]
                        participants.push(participant)
                    }
                }
                product.participants = participants

                return product
            },
            validateGroups() {
                this.dataAllParticipantsAreValid = true
                for(let productIndex in this.dataGroups) {
                    let pedalCount = 0
                    let totalWeight = 0
                    let totalParticipant = 0
                    let infoAreCompleted = true
                    let totalAdult = 0
                    let product = this.dataGroups[productIndex]
                    for(let participantIndex in product.participants) {
                        let participant = product.participants[participantIndex]

                        if (participant.firstname !== '') {
                            if (participant.age === '' || participant.weight === '') {
                                infoAreCompleted = false
                            }
                        }
                        if (participant.age !== '') {
                            if (participant.firstname === '' || participant.weight === '') {
                                infoAreCompleted = false
                            }
                        }
                        if (participant.weight !== '') {
                            if (participant.firstname === '' || participant.age === '') {
                                infoAreCompleted = false
                            }
                        }

                        if (participant.age >= 10){
                            pedalCount++
                        }

                        if (participant.age >= 18){
                            totalAdult++
                        }

                        totalWeight += participant.weight
                        totalParticipant = product.participants.length
                    }
                    let messages = []
                    let isValid = true
                    if (pedalCount < 2) {
                        messages.push(Core.Definition.getDefinition('Minimum de 2 pédaleurs (Personne de 10 ans et plus) par vélorail.'))
                        isValid = false
                    }
                    if (totalAdult > 2) {
                        messages.push(Core.Definition.getDefinition('Maximum de 2 adultes (18 ans et plus) par vélorail.'))
                        isValid = false
                    }
                    if (totalParticipant > 5) {
                        messages.push(Core.Definition.getDefinition('Maximum de 5 passages par vélorail.'))
                        isValid = false
                    }
                    if (totalWeight > 400) {
                        messages.push(Core.Definition.getDefinition('Maximum de 450 LBS par vélorail. Ajoutez un vélorail.'))
                        isValid = false
                    }
                    if (!infoAreCompleted) {
                        messages.push(Core.Definition.getDefinition('Veuillez compléter toutes les informations des participants.'))
                        isValid = false
                    }

                    if (!isValid) {
                        this.dataAllParticipantsAreValid = false
                    }

                    this.dataGroups[productIndex].messages = messages
                    this.dataGroups[productIndex].isValid = isValid
                }
            },
            onClickNext() {
                this.gotoNext()
            },
            onClickPrev() {
                this.gotoPrevious()
            },
            gotoNext() {
                this.resetAlert()
                if (this.dataStep < 3) {
                    this.dataStep ++
                }
            },
            addProduct() {
                let product = Core.Array.newObject(this.dataProduct)
                product.isValid = false
                product.messages = [
                    Core.Definition.getDefinition('Minimum de 2 pédaleurs (Personne de 10 ans et plus) par vélorail.'),
                    Core.Definition.getDefinition('Maximum de 2 adultes par vélorail.'),
                    Core.Definition.getDefinition('Maximum de 5 passages.'),
                    Core.Definition.getDefinition('Maximum de 400 LBS.')
                ]
                product.participants = [
                    {
                        id: '',
                        firstname: '',
                        age: '',
                        weight: ''
                    },
                    {
                        id: '',
                        firstname: '',
                        age: '',
                        weight: ''
                    },
                    {
                        id: '',
                        firstname: '',
                        age: '',
                        weight: ''
                    },
                    {
                        id: '',
                        firstname: '',
                        age: '',
                        weight: ''
                    },
                    {
                        id: '',
                        firstname: '',
                        age: '',
                        weight: ''
                    }
                ]
                this.dataGroups.push(product)
            },
            gotoPrevious() {
                this.resetAlert()
                if (this.dataStep > 1) {
                    this.dataStep --;
                }
            },
            resetAlert() {
                this.dataAlert.message = ''
                this.dataAlert.show = false
            },
            getAgeOptions() {
                let options = []
                let min = 0
                let max = 99
                for(let age = min; age < max; age ++) {
                    options.push({
                        value: age,
                        label: age.toString()
                    })
                }
                return options
            },
            getWeightOptions() {
                let options = []
                let min = 20
                let max = 400
                for(let weight = min; weight < max; weight = weight + 5) {
                    options.push({
                        value: weight,
                        label: weight.toString() + ' LBS'
                    })
                }
                return options
            },
            selectProduct(product) {
                this.dataProduct = product
                this.addProduct()
                this.gotoNext()
            },
            onRequestSuccessProducts(data) {
                if (data.products !== undefined) {
                    this.dataProductOptions = data.products
                }
            },
            onClickAddProduct() {
                this.addProduct()
            },
            onClickTrashProduct(productIndex) {
                this.dataGroups.splice(productIndex, 1)
            }
        }
    }
</script>
